<template>
  <v-card flat class="pa-4">
    <v-tooltip bottom  max-width="300" nudge-top="20" open-delay="1000">
      <template v-slot:activator="{on}">
        <v-checkbox v-model="preferences.poRequireApproval" v-on="on">
          <span slot="label" v-on="on">Require purchase order approval</span>
        </v-checkbox>
      </template>
      If selected, purchase orders must be approved by someone with appropriate permission,
      assuming the creator does not have permission to do so, before the PO can be issued.
    </v-tooltip>
    <v-tooltip bottom max-width="300" nudge-top="20" open-delay="1000" v-if="company.connectedToAccounting && company.qboPlan === 'Plus'">
      <template v-slot:activator="{on}">
        <v-checkbox v-model="preferences.poCreateInQBO" v-on="on">
          <span slot="label" v-on="on">Create purchase orders in QuickBooks Online</span>
        </v-checkbox>
      </template>
      Whether or not a corresponding purchase order is created in QuickBooks Online.
    </v-tooltip>
  </v-card>
</template>

<script>
export default {
  name: 'PurchasingPurchaseOrdersPreferences',
  data() {
    return {
      preferences: {}
    }
  },
  computed: {
    company() {
      return this.$store.getters.company;
    }
  },
  watch: {
    preferences: {
      async handler() {
        const results = await this.$apiCall(`mutation PurchasingPurchaseOrdersPreferences($input:PurchaseOrderPreferencesInput!) {
                                              purchaseOrderSetPreferences(input:$input) {
                                                poRequireApproval,poCreateInQBO
                                              }
                                            }`,
                                            {input:this.preferences});
        if (!results.error)
          this.$emit('update', results.data.purchaseOrderSetPreferences)
      },
      immediate: false,
      deep: true
    }
  },
  async created() {
    const results = await this.$apiCall(`query PurchasingPurchaseOrdersPreferences {
                                          purchaseOrderPreferences {
                                            poRequireApproval,poCreateInQBO
                                          }
                                        }`,
                                        {});
    if (!results.error)
      this.preferences = results.data.purchaseOrderPreferences;
  }
}
</script>